/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSfLeadSyncErrorLogs200Response } from '../models';
/**
 * SfLeadSyncLogsApi - axios parameter creator
 * @export
 */
export const SfLeadSyncLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Salesforce同期エラーログ取得
         * @summary Salesforce同期エラーログ取得
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfLeadSyncErrorLogs: async (currentPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_lead_sync_error_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SfLeadSyncLogsApi - functional programming interface
 * @export
 */
export const SfLeadSyncLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SfLeadSyncLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Salesforce同期エラーログ取得
         * @summary Salesforce同期エラーログ取得
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfLeadSyncErrorLogs(currentPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfLeadSyncErrorLogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfLeadSyncErrorLogs(currentPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SfLeadSyncLogsApi - factory interface
 * @export
 */
export const SfLeadSyncLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SfLeadSyncLogsApiFp(configuration)
    return {
        /**
         * Salesforce同期エラーログ取得
         * @summary Salesforce同期エラーログ取得
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfLeadSyncErrorLogs(currentPage?: number, options?: any): AxiosPromise<GetSfLeadSyncErrorLogs200Response> {
            return localVarFp.getSfLeadSyncErrorLogs(currentPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SfLeadSyncLogsApi - interface
 * @export
 * @interface SfLeadSyncLogsApi
 */
export interface SfLeadSyncLogsApiInterface {
    /**
     * Salesforce同期エラーログ取得
     * @summary Salesforce同期エラーログ取得
     * @param {number} [currentPage] リードリストでの現在のページネーション
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfLeadSyncLogsApiInterface
     */
    getSfLeadSyncErrorLogs(currentPage?: number, options?: AxiosRequestConfig): AxiosPromise<GetSfLeadSyncErrorLogs200Response>;

}

/**
 * Request parameters for getSfLeadSyncErrorLogs operation in SfLeadSyncLogsApi.
 * @export
 * @interface SfLeadSyncLogsApiGetSfLeadSyncErrorLogsRequest
 */
export interface SfLeadSyncLogsApiGetSfLeadSyncErrorLogsRequest {
    /**
     * リードリストでの現在のページネーション
     * @type {number}
     * @memberof SfLeadSyncLogsApiGetSfLeadSyncErrorLogs
     */
    readonly currentPage?: number
}

/**
 * SfLeadSyncLogsApi - object-oriented interface
 * @export
 * @class SfLeadSyncLogsApi
 * @extends {BaseAPI}
 */
export class SfLeadSyncLogsApi extends BaseAPI implements SfLeadSyncLogsApiInterface {
    /**
     * Salesforce同期エラーログ取得
     * @summary Salesforce同期エラーログ取得
     * @param {SfLeadSyncLogsApiGetSfLeadSyncErrorLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfLeadSyncLogsApi
     */
    public getSfLeadSyncErrorLogs(requestParameters: SfLeadSyncLogsApiGetSfLeadSyncErrorLogsRequest = {}, options?: AxiosRequestConfig) {
        return SfLeadSyncLogsApiFp(this.configuration).getSfLeadSyncErrorLogs(requestParameters.currentPage, options).then((request) => request(this.axios, this.basePath));
    }
}
